import React from 'react';
import { useSelector } from 'react-redux';
import { Carousel } from 'react-bootstrap';
import backgroundImage1 from '../../../../images/welcomeslide1.webp';
import backgroundImage2 from '../../../../images/welcomeslide2.webp';
import backgroundImage3 from '../../../../images/welcomeslide3.webp';
import './WelcomeHeader.css';

const WelcomeHeader = React.memo(({ subtitle, className = '' }) => {
  const userName = useSelector(state => state.userName);
  const backgrounds = [backgroundImage1, backgroundImage2, backgroundImage3];

  return (
    <div className={`position-relative ${className}`}>

      <div className="position-absolute top-0 start-0 w-100 h-100 rounded overflow-hidden">
        <Carousel
          controls={false}
          interval={1500}
          slide={true}
          pause={false}
        >
          {backgrounds.map((bg, index) => (
            <Carousel.Item key={index} className="carousel-item-height">
              <div
                className="w-100 h-100"
                style={{
                  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${bg})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }}
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

      <div className="welcome-header mb-4 rounded">
        <h3 className="welcome-title">
          Hello{userName ? `, ${userName}` : ''}!
        </h3>
        <p className="welcome-subtitle">{subtitle}</p>
      </div>
    </div>
  );
});

export default WelcomeHeader;